/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-07 09:32:44
 * @LastEditTime: 2025-04-22 13:55:03
 * @LastEditors: ywj@originqc.com
 */
export const menuData = [
  {
    title: '个人中心',
    id: '/user',
    path: '/user',
  },
  {
    title: '订单中心',
    id: 1,
    children: [
      {
        title: '我的订单',
        id: '/user/orderList',
        path: '/user/orderList'
      },
      {
        title: '我的发票',
        id: 'receipt',
        path: '/user/receipt',
      },
      {
        title: '售后服务',
        id: 'as/List',
        path: '/user/as/List',
      },
    ],
  },
  {
    title: '账户管理',
    id: 2,
    children: [
      {
        title: '账户信息',
        id: 'account',
        path: 'https://account.originqc.com.cn/'
      },
      {
        title: '收货地址',
        id: '/user/address',
        path: '/user/address',
      },
      {
        title: '开票信息',
        id: '/user/invoice',
        path: '/user/invoice',
      },
      {
        title: '优惠券 ',
        id: 'coupon',
        path: '/user/coupon',
      },
    ],
  },
  {
    title: '安全设置',
    id: 3,
    children: [
      {
        title: '修改密码',
        id: 'account',
        path: 'https://account.originqc.com.cn/safeSet'
      },
    ],
  },
];
